export default __webpack_public_path__ + "static/media/cargaticket.6b0cc25f.svg";